import React from 'react';
import { LineChart, BarChart2, LayoutGrid, Settings } from 'lucide-react';

const ScreensView = () => (
  <div className="flex flex-col h-full p-6">
    <h1 className="text-2xl font-bold mb-6">Stock Screens</h1>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer">
        <div className="flex items-center mb-3">
          <LineChart className="text-blue-500 mr-3" size={24} />
          <h2 className="text-lg font-semibold">Technical Analysis</h2>
        </div>
        <p className="text-gray-600">Find stocks based on technical indicators and patterns</p>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer">
        <div className="flex items-center mb-3">
          <BarChart2 className="text-blue-500 mr-3" size={24} />
          <h2 className="text-lg font-semibold">Fundamental Analysis</h2>
        </div>
        <p className="text-gray-600">Screen stocks using financial ratios and metrics</p>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer">
        <div className="flex items-center mb-3">
          <LayoutGrid className="text-blue-500 mr-3" size={24} />
          <h2 className="text-lg font-semibold">Custom Screens</h2>
        </div>
        <p className="text-gray-600">Create and save your own screening criteria</p>
      </div>
      
      <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer">
        <div className="flex items-center mb-3">
          <Settings className="text-blue-500 mr-3" size={24} />
          <h2 className="text-lg font-semibold">AI-Powered Screens</h2>
        </div>
        <p className="text-gray-600">Discover opportunities using machine learning models</p>
      </div>
    </div>
  </div>
);

export default ScreensView; 